;(function($){

    function Schedule() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });
 

        if($("#modal-schedule").length > 0) {

            $("#modal-schedule").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getUsers();
                    _.geContracts();
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    $.get(_.API + "ticket/"+_.tickets_id, function(data) {
                       
                        _.html = '<form id="form-schedule" enctype="multipart/form-data">'+
                        '<div class="row">' +                     
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="contracts_id">Contrato Vigente</label>' +
                                    '<select name="contracts_id" id="contracts_id" disabled></select>' +
                                '</div>'+
                            '</div>'+ 
                            '<div class="col-lg-7  col-md-7  col-sm-7 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="users_id">Analista</label>' +
                                    '<select name="users_id" id="users_id" disabled></select>' +
                                '</div>'+
                            '</div>'+  
                            '<div class="col-lg-5  col-md-5  col-sm-5 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="finish_close_ticket">Fechar Ticket ao Concluir Tarefa?</label>' +
                                    '<select name="finish_close_ticket" id="finish_close_ticket">'+
                                        '<option value="">Selecione</option>' +
                                        '<option value="1">Sim</option>' +
                                        '<option value="2">Não</option>' +   
                                    '</select>' +
                                '</div>'+
                            '</div>'+                           
                       '</div>'+
                       '<div class="row">' +
                            '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="start_date">Data Inicial</label>' +
                                    '<input type="date" id="start_date" name="start_date">' +
                                '</div>'+
                            '</div>'+
                            '<div class="col-lg-2  col-md-2  col-sm-2 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="start_time">Hora Inicial</label>' +
                                    '<input type="time" id="start_time" name="start_time">' +
                                '</div>'+
                            '</div>'+ 
                            '<div class="col-lg-4  col-md-4  col-sm-4 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="ending_date">Data Final</label>' +
                                    '<input type="date" id="ending_date" name="ending_date">' +
                                '</div>'+
                            '</div>'+
                            '<div class="col-lg-2  col-md-2  col-sm-2 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="ending_time">Hora Final</label>' +
                                    '<input type="time" id="ending_time" name="ending_time">' +
                                '</div>'+
                            '</div>'+                             
                       '</div>'+
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="expected_hours">Horas Previstas</label>' +
                                    '<input type="text" id="expected_hours" name="expected_hours" data-integrate>' +
                                '</div>'+
                            '</div>'+                             
                       '</div>' +
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="abstract">Descrição Resumida</label>' +
                                    '<input type="text" id="abstract" name="abstract">' +
                                '</div>'+
                            '</div>'+                             
                       '</div>' +
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="text_modal">Descrição Completa</label>' +
                                    '<textarea name="text_modal" id="text_modal" rows="5">'+data.text+'</textarea>' +
                                    '<script src="'+$("#app_url").val()+'/vendor/ckeditor/ckeditor.js"></script>'+
                                    '<script>'+
                                        'CKEDITOR.replace("text_modal", {'+
                                        'toolbar: ['+
                                            '{ name: "document", items: [ "Print"] },'+
                                            '{ name: "clipboard", items: [ "Undo", "Redo" ] },'+
                                            '{ name: "styles", items: [ "Format", "Font", "FontSize" ] },'+
                                            '{ name: "colors", items: [ "TextColor", "BGColor" ] },'+
                                            '{ name: "align", items: [ "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },'+
                                            '"/",'+
                                            '{ name: "basicstyles", items: [ "Bold", "Italic", "Underline", "Strike", "RemoveFormat", "CopyFormatting" ] },'+
                                            '{ name: "links", items: [ "Link", "Unlink" ] },'+
                                            '{ name: "paragraph", items: [ "NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote" ] },'+
                                            '{ name: "insert", items: [ "Image", "Table" ] },'+
                                            '{ name: "tools", items: [ "Maximize" ] },'+
                                            '{ name: "editing", items: [ "Scayt" ] }'+
                                        '],'+
                                        'filebrowserImageUploadUrl :"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'",'+
                                        'uploadUrl:"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'&json",'+
                                        'extraPlugins:"uploadimage",'+
                                        'extraAllowedContent: "h3{clear};h2{line-height};h2 h3{margin-left,margin-top}",'+
                                        'height: 150,'+
                                        'removeDialogTabs: "image:advanced;link:advanced"'+
                                    '});'+
                                    '</script>' +
                                '</div>'+
                            '</div>'+                             
                       '</div>'+
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="file">Anexo</label>' +
                                    '<div class="info">'+
                                        '<p>Para anexar mais de um arquivo, recomendamos arquivos .zip ou .rar</p>'+
                                    '</div>'+
                                    '<input type="file" id="file" name="file" data="upload">' +
                                '</div>'+
                            '</div>'+                             
                       '</div>' +
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<input type="hidden" id="customers_id" name="customers_id" value="'+data.customers_user.customer.customers_id+'">' +
                                    '<input type="hidden" id="tickets_id" name="tickets_id" value="'+data.tickets_id+'">' +
                                    '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                             
                       '</div></form>';
        
                    }).done(function() {
                        if(_.html != ""){
                            $('#modal-schedule').iziModal('setTitle', '<i class="fa fa-calendar" aria-hidden="true"></i> Geração de Tarefa');
                            $("#modal-schedule .content").html(_.html);

                            _.myForm = $("#form-schedule").validate({
                                rules: {
                                    contracts_id: { required: true },
                                    users_id: { required: true },
                                    start_date: { required: true},
                                    start_time: { required: true },
                                    ending_date: { required: true },
                                    ending_time: { required: true },
                                    abstract: { required: true },
                                    text_modal: { required: true },
                                    finish_close_ticket: { required: true }
                                },
                                messages: {
                                    contracts_id: { required: "Campo Obrigatório" },
                                    users_id: { required: "Campo Obrigatório" },
                                    start_date: { required: "Campo Obrigatório"},
                                    start_time: { required: "Campo Obrigatório" },
                                    ending_date: { required: "Campo Obrigatório" },
                                    ending_time: { required: "Campo Obrigatório" },
                                    abstract: { required: "Campo Obrigatório" },
                                    text_modal: { required: "Campo Obrigatório" },
                                    finish_close_ticket: { required: "Campo Obrigatório" }
                                },
                                invalidHandler: function(e) {
                                    swal({
                                        title: "Atenção!",
                                        text: "Preencha todos os campos.",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "OK!",
                                        closeOnConfirm: true
                                    });

                                },
                                submitHandler: function( form ) {

                                    for(instance in CKEDITOR.instances) {
                                        CKEDITOR.instances[instance].updateElement();
                                    }
                                
                                    $("#form-schedule .btn-send").html("Enviando...");
                                    
                                    $.ajax({
                                        type: "POST",
                                        url: _.API + "agenda",
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        data: new FormData(form),
                                        success: function(result)
                                        {
                                            $("#form-schedule .btn-send").html("Enviar");

                                            form.reset();

                                            $('#modal-schedule').iziModal('close'); 

                                            swal({
                                                title: result.message,
                                                text: "Click no botão para fechar!",
                                                type: "success",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: false
                                            }).then(function() {
                                              location.reload();
                                            });                                        
                                        },
                                        error: function(response) {
                                            var errors = $.parseJSON(response.responseText);
                                            
                                            swal({
                                                title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                                text: "Click no botão para fechar!",
                                                type: "warning",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: true
                                            });

                                           
                                            $myForm.showErrors(errors);
                                            
                                            $("#form-schedule .btn-send").html("Enviar");
                                        }
                                    });
                                }
                            });
                        }
                    });                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.tickets_id   = null;
                    _.customers_id = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-schedule .content").html("");
                    $('#modal-schedule').iziModal('setTitle', "");
                }        
            });
        }

        if($("#modal-proposal-client").length > 0) { 
            $("#modal-proposal-client").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getUsers(); 
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    $.get(_.API + "ticket/"+_.tickets_id, function(data) { 
                        _.html = '<form id="form-proposal-client" enctype="multipart/form-data">'+
                       '<div class="row">' +
                       '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                           '<div class="form-row">' +
                               '<label for="abstract">Ticket</label>' +
                               '<input type="text" id="ticket" name="ticket" value="'+data.title+'">' +
                           '</div>'+
                       '</div>'+                             
                        '</div>' + 
                       '<div class="row">' +
                       '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                           '<div class="form-row">' +
                               '<label for="abstract">Assunto</label>' +
                               '<input type="text" id="subject" name="subject" value="'+data.subject+'">' +
                           '</div>'+
                       '</div>'+                             
                        '</div>' +                  
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="text_modal">Descrição da Proposta</label>' +
                                    '<textarea name="text_modal" id="text_modal" rows="5"></textarea>' +
                                    '<script src="'+$("#app_url").val()+'/vendor/ckeditor/ckeditor.js"></script>'+
                                    '<script>'+
                                        'CKEDITOR.replace("text_modal", {'+
                                        'toolbar: ['+
                                            '{ name: "document", items: [ "Print"] },'+
                                            '{ name: "clipboard", items: [ "Undo", "Redo" ] },'+
                                            '{ name: "styles", items: [ "Format", "Font", "FontSize" ] },'+
                                            '{ name: "colors", items: [ "TextColor", "BGColor" ] },'+
                                            '{ name: "align", items: [ "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },'+
                                            '"/",'+
                                            '{ name: "basicstyles", items: [ "Bold", "Italic", "Underline", "Strike", "RemoveFormat", "CopyFormatting" ] },'+
                                            '{ name: "links", items: [ "Link", "Unlink" ] },'+
                                            '{ name: "paragraph", items: [ "NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote" ] },'+
                                            '{ name: "insert", items: [ "Image", "Table" ] },'+
                                            '{ name: "tools", items: [ "Maximize" ] },'+
                                            '{ name: "editing", items: [ "Scayt" ] }'+
                                        '],'+
                                        'filebrowserImageUploadUrl :"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'",'+
                                        'uploadUrl:"'+$("#app_url").val()+'/ckeditor/images?_token='+$('meta[name="csrf-token"]').attr('content')+'&json",'+
                                        'extraPlugins:"uploadimage",'+
                                        'extraAllowedContent: "h3{clear};h2{line-height};h2 h3{margin-left,margin-top}",'+
                                        'height: 150,'+
                                        'removeDialogTabs: "image:advanced;link:advanced"'+
                                    '});'+
                                    '</script>' +
                                '</div>'+
                            '</div>'+                             
                       '</div>'+
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<input type="hidden" id="tickets_id" name="tickets_id" value="'+data.tickets_id+'">' +
                                    '<button class="pull-right btn-primary btn-send">Enviar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                             
                       '</div></form>';
        
                    }).done(function() {
                        if(_.html != ""){
                            $('#modal-proposal-client').iziModal('setTitle', '<i class="fa fa-history" aria-hidden="true"></i> Enviar proposta');
                            $("#modal-proposal-client .content").html(_.html);

                            _.myForm = $("#proposal-client").validate({
                                rules: { 
                                    tickets_id: { required: true } 
                                },
                                messages: { 
                                    tickets_id: { required: "Campo Obrigatório" }
                                },
                                invalidHandler: function(e) {
                                    swal({
                                        title: "Atenção!",
                                        text: "Preencha todos os campos.",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "OK!",
                                        closeOnConfirm: true
                                    });

                                },
                                submitHandler: function( form ) {
 
                                
                                    $("#form-proposal-client .btn-send").html("Enviando...");
                                    console.log(_.API + "enviar-proposta");
                                    $.ajax({
                                        type: "POST",
                                        url: _.API + "enviar-proposta",
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        data: new FormData(form),
                                        success: function(result)
                                        {
                                            $("#form-proposal-client .btn-send").html("Enviar");

                                            form.reset();

                                            $('#modal-proposal-client').iziModal('close'); 

                                            swal({
                                                title: result.message,
                                                text: "Click no botão para fechar!",
                                                type: "success",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: false
                                            }).then(function() {
                                              location.reload();
                                            });                                        
                                        },
                                        error: function(response) {
                                            var errors = $.parseJSON(response.responseText);
                                            
                                            swal({
                                                title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                                text: "Click no botão para fechar!",
                                                type: "warning",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: true
                                            });

                                           
                                            $myForm.showErrors(errors);
                                            
                                            $("#form-proposal-client .btn-send").html("Enviar");
                                        }
                                    });
                                }
                            });
                        }
                    });                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.tickets_id   = null; 
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-proposal-client .content").html("");
                    $('#modal-proposal-client').iziModal('setTitle', "");
                }        
            });
        }

        if($("#modal-estimate-time").length > 0) {

            $("#modal-estimate-time").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getUsers(); 
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    $.get(_.API + "ticket/"+_.tickets_id, function(data) {
                       
                        _.html = '<form id="form-estimate-time" enctype="multipart/form-data">'+
                        '<div class="row">' +                     
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+  
                                '<div class="form-row">' +
                                    '<label for="users_id">Analista</label>' +
                                    '<select name="users_id" id="users_id" disabled></select>' +
                                '</div>'+
                            '</div>'+   
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<input type="hidden" id="tickets_id" name="tickets_id" value="'+data.tickets_id+'">' +
                                    '<button class="pull-right btn-primary btn-send">Enviar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                             
                       '</div></form>';
        
                    }).done(function() {
                        if(_.html != ""){
                            $('#modal-estimate-time').iziModal('setTitle', '<i class="fa fa-history" aria-hidden="true"></i> Estimativa de Tarefa');
                            $("#modal-estimate-time .content").html(_.html);

                            _.myForm = $("#form-estimate-time").validate({
                                rules: { 
                                    users_id: { required: true } 
                                },
                                messages: { 
                                    users_id: { required: "Campo Obrigatório" }
                                },
                                invalidHandler: function(e) {
                                    swal({
                                        title: "Atenção!",
                                        text: "Preencha todos os campos.",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "OK!",
                                        closeOnConfirm: true
                                    });

                                },
                                submitHandler: function( form ) {
 
                                
                                    $("#form-estimate-time .btn-send").html("Enviando...");
                                    
                                    $.ajax({
                                        type: "POST",
                                        url: _.API + "estimativa-de-tarefa",
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        data: new FormData(form),
                                        success: function(result)
                                        {
                                            $("#form-estimate-time .btn-send").html("Enviar");

                                            form.reset();

                                            $('#modal-estimate-time').iziModal('close'); 

                                            swal({
                                                title: result.message,
                                                text: "Click no botão para fechar!",
                                                type: "success",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: false
                                            }).then(function() {
                                              location.reload();
                                            });                                        
                                        },
                                        error: function(response) {
                                            var errors = $.parseJSON(response.responseText);
                                            
                                            swal({
                                                title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                                text: "Click no botão para fechar!",
                                                type: "warning",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: true
                                            });

                                           
                                            $myForm.showErrors(errors);
                                            
                                            $("#form-estimate-time .btn-send").html("Enviar");
                                        }
                                    });
                                }
                            });
                        }
                    });                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.tickets_id   = null; 
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-estimate-time .content").html("");
                    $('#modal-estimate-time').iziModal('setTitle', "");
                }        
            });
        }

        if($("#modal-estimate-time-resend").length > 0) {

            $("#modal-estimate-time-resend").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getUsers(); 
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    $.get(_.API + "ticket/"+_.tickets_id, function(data) {
                       
                        _.html = '<form id="form-estimate-time" enctype="multipart/form-data">'+
                        '<div class="row">' +                     
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+  
                                '<div class="form-row">' +
                                    '<label for="users_id">Analista</label>' +
                                    '<select name="users_id" id="users_id" disabled></select>' +
                                '</div>'+
                            '</div>'+   
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<input type="hidden" id="tickets_id" name="tickets_id" value="'+data.tickets_id+'">' +
                                    '<button class="pull-right btn-primary btn-send">Enviar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                             
                       '</div></form>';
        
                    }).done(function() {
                        if(_.html != ""){
                            $('#modal-estimate-time-resend').iziModal('setTitle', '<i class="fa fa-history" aria-hidden="true"></i> Estimativa de Tarefa');
                            $("#modal-estimate-time-resend .content").html(_.html);

                            _.myForm = $("#form-estimate-time").validate({
                                rules: { 
                                    users_id: { required: true } 
                                },
                                messages: { 
                                    users_id: { required: "Campo Obrigatório" }
                                },
                                invalidHandler: function(e) {
                                    swal({
                                        title: "Atenção!",
                                        text: "Preencha todos os campos.",
                                        type: "warning",
                                        showCancelButton: false,
                                        confirmButtonColor: "#DD6B55",
                                        confirmButtonText: "OK!",
                                        closeOnConfirm: true
                                    });

                                },
                                submitHandler: function( form ) {
 
                                
                                    $("#form-estimate-time .btn-send").html("Enviando...");
                                    
                                    $.ajax({
                                        type: "POST",
                                        url: _.API + "estimativa-de-tarefa",
                                        cache: false,
                                        contentType: false,
                                        processData: false,
                                        data: new FormData(form),
                                        success: function(result)
                                        {
                                            $("#form-estimate-time .btn-send").html("Enviar");

                                            form.reset();

                                            $('#modal-estimate-time-resend').iziModal('close'); 

                                            swal({
                                                title: result.message,
                                                text: "Click no botão para fechar!",
                                                type: "success",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: false
                                            }).then(function() {
                                              location.reload();
                                            });                                        
                                        },
                                        error: function(response) {
                                            var errors = $.parseJSON(response.responseText);
                                            
                                            swal({
                                                title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                                text: "Click no botão para fechar!",
                                                type: "warning",
                                                showCancelButton: false,
                                                confirmButtonColor: "#DD6B55",
                                                confirmButtonText: "Fechar!",
                                                closeOnConfirm: true
                                            });

                                           
                                            $myForm.showErrors(errors);
                                            
                                            $("#form-estimate-time .btn-send").html("Enviar");
                                        }
                                    });
                                }
                            });
                        }
                    });                
                },
                onClosed: function() {
                    _.uri          = null;
                    _.tickets_id   = null; 
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-estimate-time-resend .content").html("");
                    $('#modal-estimate-time-resend').iziModal('setTitle', "");
                }        
            });
        }
 
        $("button.btn-create-schedule").on("click", function(e){
            e.preventDefault();
            _.tickets_id   = $(this).data('ticket');
            _.customers_id = $(this).data('customer');
            $('#modal-schedule').iziModal('open');           
        });

        $("button.btn-create-estimate-time").on("click", function(e){
            e.preventDefault(); 
            _.tickets_id   = $(this).data('ticket');
            $('#modal-estimate-time').iziModal('open');            
        });

        $("button.btn-send-proposal").on("click", function(e){
            e.preventDefault(); 
            _.tickets_id   = $(this).data('ticket');  
            $('#modal-proposal-client').iziModal('open');            
        });

        $("button.btn-resend-request-expected-hour").on("click", function(e){
            e.preventDefault(); 
            _.tickets_id   = $(this).data('ticket');    
            _.users_id   = $(this).data('expected-user');    
            
            $('#modal-estimate-time-resend').iziModal('open');   
        });

        $("button.btn-resend-email-expected").on("click", function(e){
            e.preventDefault(); 
            _.tickets_id   = $(this).data('ticket');    
            _.users_id   = $(this).data('expected-user-id');    

            if(_.tickets_id != "" && _.users_id != "")
            {
                $(this).prop('disabled', true);
                
                $.ajax({
                    type: "GET",
                    url: _.API + "estimativa-de-tarefa-salvar/"+_.tickets_id+'/'+_.users_id,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function(result)
                    {

                        $(this).prop('disabled', false);
                        swal({
                            title: result.message,
                            text: "Click no botão para fechar!",
                            type: "success",
                            showCancelButton: false,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Fechar!",
                            closeOnConfirm: false
                        }).then(function() {
                          location.reload();
                        });                                        
                    },
                    error: function(response) {
                        var errors = $.parseJSON(response.responseText);
                        
                        
                        swal({
                            title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                            text: "Click no botão para fechar!",
                            type: "warning",
                            showCancelButton: false,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Fechar!",
                            closeOnConfirm: true
                        });

                    }
                });
                
            }
             
        });

        $("button.btn-apont-analisty").on("click", function(e){
            e.preventDefault(); 
            _.data_apont_start   = $(this).data('apont-start');     
            _.data_apont_ending   = $(this).data('apont-ending'); 
            _.users_id   = $(this).data('users-id');      
            console.log($(this).data('apont-start'));
            if(_.data_apont_start != "" && _.data_apont_start != "" && _.users_id != "")
            {
                $(this).prop('disabled', true);
                
                $.ajax({
                    type: "GET",
                    url: _.API + "falta-apontamento/"+_.data_apont_start+'/'+_.data_apont_ending+'/'+_.users_id,
                    cache: false,
                    contentType: false,
                    processData: false,
                    success: function(result)
                    {

                        $(this).prop('disabled', false);
                        swal({
                            title: result.message,
                            text: "Click no botão para fechar!",
                            type: "success",
                            showCancelButton: false,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Fechar!",
                            closeOnConfirm: false
                        }).then(function() {
                          location.reload();
                        });                                        
                    },
                    error: function(response) {
                        var errors = $.parseJSON(response.responseText);
                        
                        
                        swal({
                            title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                            text: "Click no botão para fechar!",
                            type: "warning",
                            showCancelButton: false,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: "Fechar!",
                            closeOnConfirm: true
                        });

                    }
                });
                
            }
             
        });

         
    }

    
        
    
    Schedule.prototype.getUsers = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/usuarios", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
                var selected = (_.users_id == index) ? 'selected' : '';

               html += '<option value="'+ index +'" '+selected+'>'+ value +'</option>';
            });

            $("select#users_id").attr('disabled', false).html(html);
            $("select#users_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    };

    Schedule.prototype.geContracts = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/contratos/"+_.customers_id, function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#contracts_id").attr('disabled', false).html(html);
            $("select#contracts_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    };   

   	new Schedule();

}(jQuery));